import { Outlet } from 'react-router-dom';
// @mui
import { alpha, styled } from '@mui/material/styles';
import { Box, IconButton, Link, Stack, Typography } from '@mui/material';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import LightModeIcon from '@mui/icons-material/LightMode';
// components
import { useColorMode } from '../../contexts/ColorModeContext';

// ----------------------------------------------------------------------

const StyledHeader = styled('header')(({ theme }) => ({
  top: 0,
  left: 0,
  width: '100%',
  position: 'sticky',
  zIndex: theme.zIndex.appBar,
  backdropFilter: 'blur(12px)',
  WebkitBackdropFilter: 'blur(12px)',
  backgroundColor: alpha(theme.palette.background.default, 0.85),
  borderBottom: `1px solid ${alpha(theme.palette.divider, 0.08)}`,
  padding: theme.spacing(1.5, 3),
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(2, 4),
  },
}));

const GradientText = styled(Typography)(({ theme }) => ({
  background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`,
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  backgroundClip: 'text',
  display: 'inline-block',
  fontStyle: 'italic',
  fontWeight: 300,
  letterSpacing: '-0.02em',
}));

// ----------------------------------------------------------------------

export default function SimpleLayout() {
  const { mode, toggleColorMode } = useColorMode();

  return (
    <>
      <StyledHeader>
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Link href="/" underline="none">
            <GradientText
              sx={{
                fontSize: { xs: '1.6rem', sm: '2.4rem', md: '2.8rem' },
                lineHeight: 1.2,
              }}
            >
              Lòi Collections
            </GradientText>
          </Link>
          <Box>
            <IconButton
              onClick={toggleColorMode}
              color="inherit"
              aria-label="toggle dark mode"
              sx={{
                borderRadius: 2,
                border: (theme) => `1px solid ${alpha(theme.palette.divider, 0.2)}`,
                backdropFilter: 'blur(4px)',
                transition: 'all 0.2s ease',
                '&:hover': {
                  backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.1),
                  borderColor: (theme) => alpha(theme.palette.primary.main, 0.4),
                },
              }}
            >
              {mode === 'dark' ? <LightModeIcon fontSize="small" /> : <DarkModeIcon fontSize="small" />}
            </IconButton>
          </Box>
        </Stack>
      </StyledHeader>

      <Outlet />
    </>
  );
}
